export default {
  businessModek: {
    title: {
      fr: "Comment ?",
      en: "How ?",
    },
    description: {
      description1: {
        fr: "Application\n<strong>Gratuite</strong>",
        en: "App\n<strong>Free</strong>",
      },
      description2: {
        fr: "Matériel\n<strong>Achat</strong>",
        en: "Hardware\n<strong>Purchase</strong>",
      },
      description3: {
        fr: "Hypervision\n<strong>Abonnement</strong>",
        en: "Hypervision\n<strong>Membership</strong>",
      },
    },
  },
};
